export const state = {
    cities: [],
    districts: [],
    wards: []
}
